import { Bell, X } from "lucide-react";
import { doc, updateDoc } from "firebase/firestore";
import { COL } from "@zociety/core";
import { db } from "@/lib/firebase";
import { useAuth } from "@/contexts/AuthContext";
import { useNotificaciones } from "@/hooks/useDatos";

const RELATIVO = new Intl.RelativeTimeFormat("es-MX", { numeric: "auto" });

function haceCuanto(ms: number): string {
  const segundos = Math.round((ms - Date.now()) / 1000);
  const escalas: [number, Intl.RelativeTimeFormatUnit][] = [
    [60, "second"],
    [3600, "minute"],
    [86400, "hour"],
    [604800, "day"],
    [2629800, "week"],
  ];
  for (const [limite, unidad] of escalas) {
    if (Math.abs(segundos) < limite) {
      const divisor = limite === 60 ? 1 : limite / (limite === 3600 ? 60 : limite === 86400 ? 3600 : limite === 604800 ? 86400 : 604800);
      return RELATIVO.format(Math.round(segundos / divisor), unidad);
    }
  }
  return new Date(ms).toLocaleDateString("es-MX", { day: "numeric", month: "short" });
}

export default function PanelNotificaciones({ onCerrar }: { onCerrar: () => void }) {
  const { cuenta } = useAuth();
  const { datos } = useNotificaciones();

  const marcarLeida = async (id: string) => {
    if (!cuenta) return;
    // Las reglas solo permiten al dueño cambiar el campo `leida`.
    await updateDoc(doc(db, COL.USUARIOS, cuenta.uid, COL.NOTIFICACIONES, id), { leida: true }).catch(
      () => undefined
    );
  };

  return (
    <div className="velo" onClick={onCerrar} role="dialog" aria-modal="true" aria-label="Notificaciones">
      <div className="modal" onClick={(e) => e.stopPropagation()} style={{ maxWidth: 480 }}>
        <header className="fila entre" style={{ marginBottom: "var(--e4)" }}>
          <h4 className="fila g2">
            <Bell size={18} aria-hidden />
            Notificaciones
          </h4>
          <button className="btn btn-icono btn-fantasma" onClick={onCerrar} aria-label="Cerrar">
            <X size={18} />
          </button>
        </header>

        {datos.length === 0 ? (
          <p className="suave pequeno" style={{ textAlign: "center", paddingBlock: "var(--e6)" }}>
            No tienes notificaciones.
          </p>
        ) : (
          <ul className="pila g2" style={{ listStyle: "none" }}>
            {datos.map((n) => (
              <li
                key={n.id}
                className="tarjeta"
                style={{
                  padding: "var(--e4)",
                  borderColor: n.leida ? "var(--borde)" : "var(--borde-acento)",
                  cursor: n.leida ? "default" : "pointer",
                }}
                onClick={() => !n.leida && marcarLeida(n.id)}
              >
                <div className="fila entre g2" style={{ alignItems: "flex-start" }}>
                  <strong className="pequeno">{n.titulo}</strong>
                  <span className="diminuto tenue" style={{ whiteSpace: "nowrap" }}>
                    {haceCuanto(n.fecha_ms)}
                  </span>
                </div>
                <p className="pequeno suave" style={{ marginTop: "var(--e1)" }}>
                  {n.mensaje}
                </p>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}
